export default __webpack_public_path__ + "static/media/mic.eca87d01.svg";